import React, { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { createTimezonedDate } from '@rd-web-markets/shared/dist/util/date';
import { Table } from '@rd-web-markets/shared/dist/util';
import Modal from '@rd-web-markets/shared/dist/util/Modal';
import { Button } from '@rd-web-markets/shared/dist/util/buttons';
const StaffCostTemplateImportStatus = _ref => {
  let {
    importStatus
  } = _ref;
  const {
    t
  } = useTranslation();
  const [modalShow, setModalShow] = useState(false);
  if (!importStatus.updated_at) return null;
  const dateImportAttempted = createTimezonedDate(new Date(importStatus.updated_at), true).toCustomLocaleTimeString();
  const notImportedMessage = "".concat(t('attempted_import_by'), " ").concat(importStatus.uploaded_by, " at ").concat(dateImportAttempted);
  const pendingMessage = "".concat(t('your_file_has_been_uploaded_successfully'), " by ").concat(importStatus.uploaded_by, " at ").concat(dateImportAttempted, ". ").concat(t('please_wait_while_data_is_being_imported'), ".");
  const importedMessage = "".concat(t('imported_by'), " ").concat(importStatus.uploaded_by, " at ").concat(dateImportAttempted);
  const importStatusMessage = () => {
    if (importStatus.import_status === 'imported_successfully') {
      return importedMessage;
    } else if (importStatus.import_status === 'pending') {
      return pendingMessage;
    } else {
      return /*#__PURE__*/React.createElement("span", null, notImportedMessage, ".", /*#__PURE__*/React.createElement(Button, {
        style: {
          padding: 0,
          margin: 0
        },
        variant: "link",
        onClick: () => setModalShow(true),
        className: "ms-1"
      }, "You can check them here"));
    }
  };
  const headers = [{
    text: t('error')
  }, {
    text: t('details')
  }];
  const rows = importStatus === null || importStatus === void 0 ? void 0 : importStatus.import_messages.map(m => ({
    columns: [m.message, m.details]
  }));
  const modalBody = /*#__PURE__*/React.createElement(Table, {
    headers: headers,
    rows: rows,
    showControls: false
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Modal, {
    show: modalShow,
    size: "xl",
    title: t('import_errors'),
    renderBody: () => modalBody,
    onHide: () => setModalShow(false),
    closeText: t('close')
  }), /*#__PURE__*/React.createElement(Col, null, importStatusMessage()));
};
export default StaffCostTemplateImportStatus;